import { useDispatch, useSelector } from "react-redux";
import { DropdownProps } from "@skyportal/ui-kit";
import { useCallback } from "react";
import { getContractDropdownOptions, getSelectedContractId } from "store/selectors/contractSelectors";
import { setSelectedContractId } from "store/slices/contractsSlice";

interface UseContractDropdown {
  options: DropdownProps["options"];
  handleChange: DropdownProps["onChange"];
  value: string;
}

const useContractDropdown = (): UseContractDropdown => {
  const dispatch = useDispatch();

  return {
    value: useSelector(getSelectedContractId) ?? "",
    handleChange: useCallback(
      (value: string) => {
        dispatch(setSelectedContractId(value));
      },
      [dispatch]
    ),
    options: useSelector(getContractDropdownOptions),
  };
};

export default useContractDropdown;
